/* eslint-disable no-console */
import { serverApi } from 'api';
import ParticleEffect from 'components/ParticleEffect';
import SEO from 'components/SEO';
import FacebookTypes from 'constants/facebookTypes';
import ContactForm from 'containers/ContactForm';
import React from 'react';
import { useHistory } from 'react-router-dom';
import logo from './logo-bw.jpg';

const Contact = () => {
  const history = useHistory();
  const handleEmail = async ({ fullName, email, phone, company, message }) => {
    try {
      await serverApi.post('/email', {
        senderEmail: email,
        subject: `${fullName || 'Sans nom'} CONTACT DU SITE`,
        htmlBody: `
        Personne à contacter: ${fullName || 'acune information'}
        Telephone: ${phone || 'acune information'}
        Entreprise: ${company || 'acune information'}
        Message: ${message || 'acune information'}
        `,
      });
    } catch (error) {
      console.log(error, error.response);
    }

    history.push('/');
  };

  return (
    <>
      <div>
        <div
          style={{
            height: '100vh',
            width: '100vw',
            backgroundImage: 'url(/assets/images/contact/bg.webp)',
            backgroundSize: 'cover',
            // opacity: 0.5,
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: -4,
          }}
        />
        <SEO
          title="Pulp Ground | Contact Page"
          image="/assets/helmet/Contact.jpg"
          description="Pulp Ground is continually helping businesses thrive. If you have any questions or want to work with us, please don't hesitate to contact us."
          type={FacebookTypes.article}
        />
        {/* eslint-disable-next-line no-console */}
        <ContactForm onSubmit={handleEmail} />
        <ParticleEffect width={50} height={75} offsetTop={15} offsetLeft={40} image={logo} />
      </div>
    </>
  );
};

export default Contact;
